var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KycSSNForm',_vm._b({on:{"skip":_vm.onSkip,"submit":_vm.onSubmit}},'KycSSNForm',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }